<div class="modal-form container-fluid" (window:resize)="onWindowResize($event)" id="modalContainer">

    <mat-dialog-content class="mat-typography" *ngIf="pageMode$ | async as pageMode">

        <div class="row">
            <div class="col-10">
                <h2 mat-dialog-title class="jumbotron-heading">
                    <h3 *ngIf="isApplicationDocument">{{task?.name}}</h3>
                    <h3 *ngIf="isEmailAttachmentMode">{{dataParam?.emailAttachment?.name}}</h3>
                    <h3 *ngIf="isVaultDocument">{{vaultDocument?.name}}</h3>
                </h2>
            </div>
            <div class="col-2" style="text-align: right;">
                <button (click)="onCancel()" class="btn white"><fa-icon class="close-X" icon="xmark"></fa-icon></button>
            </div>
        </div>

        <div class="row" *ngIf="isEmailAttachmentMode">
            <div class="col-12">
                <button class="btn white" (click)="onAddFileToLoan()">Add File to Loan</button>
            </div>
        </div>

        <!-- Vault Document -->
        <ng-container *ngIf="(pagePurpose$ | async) === 'vaultDocument'">
            {{vaultDocument?.description}}
            <!-- <div *ngIf="pageMode !== 'editDocumentName'">{{vaultDocument?.name}}&nbsp;&nbsp;<a
                    (click)="onEditDocumentName()"><fa-icon icon="edit"></fa-icon></a></div>
            <div *ngIf="pageMode === 'editDocumentName'">
                <input type="text" [(ngModel)]="documentName" />&nbsp;&nbsp;
                <a (click)="onSaveDocumentName()">Save</a>&nbsp;&nbsp;
                <a (click)="onCancelDocumentNameEdit()">Cancel</a>
            </div> -->
        </ng-container>

        <!-- Application Document Stuff -->
        <ng-container *ngIf="(pagePurpose$ | async) === 'ApplicationDocument'">
            <div *ngIf="pageMode !== 'editDocumentName'">{{task?.document?.name}}&nbsp;&nbsp;<a
                    (click)="onEditDocumentName()"><fa-icon icon="edit"></fa-icon></a></div>
            <div *ngIf="pageMode === 'editDocumentName'">
                <input type="text" [(ngModel)]="documentName" />&nbsp;&nbsp;
                <a (click)="onSaveDocumentName()">Save</a>&nbsp;&nbsp;
                <a (click)="onCancelDocumentNameEdit()">Cancel</a>
            </div>

            <!-- Can only accept / reject items that are uploaded, but not already accepted or rejected / AKA status == "Uploaded" -->

            <div *ngIf="(this.lgvUserSvc.IsProcessor$ | async) && isUploadedStatus() && pageMode !== 'rejectMode'">
                <div class="float-end">
                    <button (click)="onGoToRejectMode()" class="btn red margin-15-right">Reject</button>
                    <button (click)="onAcceptDocument()" class="btn btn-primary">Accept</button>
                </div>
            </div>

            <ng-container *ngIf="pageMode === 'rejectMode'">

                <div class="Vert-15"></div>
                <div class="alert alert-info">
    
                    <form [formGroup]="_rejectForm">
                        <div class="section-header">Reject Task</div>
    
                        <!-- <hr/>
                        Selected Reason ID: {{selectedReason?.ID}} | {{selectedReason?.Display}}   Notes: {{rejectNotes}}
                        <hr/> -->
    
                        <div class="row">
                            <div class="col-3">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Reason for Rejection</mat-label>
                                    <mat-select placeholder="Select a reason for rejection"
                                        (selectionChange)="onSelectReason($event.value)" formControlName="reason">
                                        <mat-option *ngFor="let item of rejectReasons" [value]="item">
                                            {{item.Display}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
    
                            <div class="col-5">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Notes</mat-label>
                                    <textarea matInput placeholder="Add any additional comments to the borrower here"
                                        formControlName="notes" maxlength="1000" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="10"></textarea>
                                </mat-form-field>
                            </div>
    
                            <div class="col-4">
                                <div class="float-end"><button (click)="onRejectDocument()" class="btn btn-primary"
                                        [disabled]="!_rejectForm.valid">Send to
                                        Client</button></div>
                                <div class="float-end"><button (click)="onResetPageMode()"
                                        class="btn btn-secondary margin-15-right">Cancel</button></div>
                            </div>
                        </div>
                    </form>
    
    
    
    
    
                </div>
    
            </ng-container>

        </ng-container>

        <div class="Vert-15"></div>

        <div id="documentIFrameViewer" class="document-container">
            <!-- PDF will be displayed here -->
        </div>

    </mat-dialog-content>
</div>